<script>
import { filter } from '../../filter/index.js'
export default {
  name: 'readTextTwo',
  functional: true,
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    single: {
      //是否在后面显示分数组件
      type: Number,
      default: null,
    },
    total: {
      //配合single使用，展示的总分数
      type: Number,
      default: null,
    },
    allowHalf: {
      //配合single使用，是否开启半星，用于计算总分数
      type: Boolean,
      default: true,
    },
    whiteSpace: {
      // 是否显示空格
      type: Boolean,
      default: false,
    },
    valueStyle: {
      type: Object,
      default: () => ({ color: '#40A300' }),
    },
    value: null,
    subValue: null,
    type: '',
    format: '',
    symbol: '',
    isLongText: {
      type: Boolean,
      default: false,
    },
    // 当值不存在的时候用符号("-")代替
    noValueSymbol: {
      type: String,
      default: '-',
    },
    // 是否显示穿过文本的线
    lineThrough: {
      type: Boolean,
      default: false,
    },
  },
  render(h, context) {
    const { value, subValue, noValueSymbol, valueStyle } = context.props
    function getNode(val, styleVal) {
      let sVnode, cData
      if (!val && val !== 0 && val !== false) {
        cData = Object.assign({ class: { 'readText-span': true } }, context.data)
        sVnode = h('span', cData, [noValueSymbol])
      } else {
        const { isLongText, whiteSpace, lineThrough, type, format, symbol } = context.props
        const isTitle = type && format && symbol
        const fValue = type ? filter(val, type, format, symbol) || '-' : val
        cData = Object.assign(
          {
            class: {
              'readText-span': true,
              ellipsis: isLongText,
              'white-space': whiteSpace,
              'line-through': lineThrough,
            },
            style: { ...styleVal },
            attrs: {
              title: isLongText && isTitle ? fValue : '',
            },
          },
          context.data
        )
        if (!cData.style) {
          //解决表单中未配置style时，style为undefined
          cData.style = { ...styleVal }
        }
        sVnode = h('span', cData, [fValue])
      }
      return sVnode
    }
    if (context.props.single) {
      return h(
        'span',
        {
          style: {
            display: 'inline-flex',
            alignItems: 'center',
          },
        },
        [
          getNode(value, valueStyle),
          h('pgRate', {
            style: {
              marginLeft: '5px',
            },
            props: {
              single: context.props.single,
              allowHalf: context.props.allowHalf,
              total: context.props.total,
              count: 1,
              disabled: true,
              value: subValue,
            },
          }),
        ]
      )
    }
    return h('span', {}, [getNode(value, valueStyle), '/', getNode(subValue)])
  },
}
</script>
